import { env } from "./constants/env";


const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('userToken'); // Retrieve token from localStorage

  if (!token) {
    // Redirect to an external URL if token is not found
    window.location.href = env.siteUrl
    return null; // Prevent rendering the protected content
  }

  // Render children if token is valid
  return children;
};

export default ProtectedRoute;